import { forwardRef, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { siteApi } from '@/api/endpoints/site';
import { brand } from '@/brand';

// Sitekey один на все инстансы (хардкод в common/config/main.php),
// поэтому достаточно одного запроса за время жизни вкладки.
let cachedSiteKey: string | null = null;

export const RecaptchaField = forwardRef<ReCAPTCHA>(function RecaptchaField(_, ref) {
  const [siteKey, setSiteKey] = useState<string | null>(cachedSiteKey);

  useEffect(() => {
    if (cachedSiteKey) return;
    void siteApi.recaptchatoken().then((key) => {
      cachedSiteKey = key;
      setSiteKey(key);
    });
  }, []);

  // Placeholder под высоту normal-виджета (304×78 в Google reCAPTCHA v2),
  // чтобы форма не «прыгала» при подгрузке sitekey.
  if (!siteKey) return <div style={{ height: 78 }} />;

  const widget = <ReCAPTCHA ref={ref} sitekey={siteKey} size="normal" />;

  // Карточка (layout.auth = 'card') на телефоне: внутри 20px полей до 375px
  // ширины остаётся меньше 304px, которые занимает виджет, — он вылезал бы за
  // карточку. Там его чуть ужимаем; transform на раскладку не влияет, поэтому
  // обёртка режет остаток, а высота остаётся прежней.
  if (brand.layout.auth === 'card') {
    return (
      <div className="max-[375px]:overflow-hidden">
        <div className="max-[375px]:origin-left max-[375px]:scale-[0.94]">{widget}</div>
      </div>
    );
  }

  return widget;
});
